export default "__VITE_ASSET__CzEuLimn__"